import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize } from '../../utils';

export const themeSelectorStyles: SxStyles = {
  picker: {
    fontSize: theme.typography.fs14 as any,
    height: '100%',
    width: '100%',
    minWidth: 0,
    '& .MuiOutlinedInput-root, & .MuiInputBase-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      padding: 0,
      minHeight: 'auto',
      height: 'auto',
      margin: 0,
      '& fieldset': { border: 'none' },
      '&:before, &:after': { borderBottom: '0 !important' },
    },
    '& .MuiSelect-select, & .MuiSelect-selectMenu': {
      background: 'transparent',
      border: 'none',
      padding: 0,
      minHeight: 'auto',
    },
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      borderBottom: '0 !important',
    },
    '& .MuiInput-root:hover:not(.Mui-disabled):before': {
      borderBottom: '0 !important',
    },
    '& .MuiInput-input, & .MuiInputBase-input': {
      padding: 0,
      display: 'flex',
      alignItems: 'center',
    },
    '& .icon': {
      height: getResponsiveSize(20),
      width: getResponsiveSize(20),
      lineHeight: getResponsiveSize(20),
      marginRight: 0,
      display: 'inline-block',
    },
  },
  pickerLarge: {
    fontSize: getResponsiveSize(28),
    height: getResponsiveSize(30),
    width: getResponsiveSize(30),
    '& .MuiOutlinedInput-root, & .MuiInputBase-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      padding: 0,
      minHeight: 'auto',
      height: 'auto',
      margin: 0,
      '& fieldset': { border: 'none' },
      '&:before, &:after': { borderBottom: '0 !important' },
    },
    '& .MuiSelect-select, & .MuiSelect-selectMenu': {
      background: 'transparent',
      border: 'none',
      padding: 0,
      minHeight: 'auto',
    },
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      borderBottom: '0 !important',
    },
    '& .MuiInput-root:hover:not(.Mui-disabled):before': {
      borderBottom: '0 !important',
    },
  },
  menuPaper: {
    '& .MuiMenu-list': {
      backgroundColor: 'white !important',
      '& li:hover, & li:focus': {
        backgroundColor: '#f1f1f1',
      },
    },
  },
};
